function checkPaymentIntent(searchParams: URLSearchParams): boolean {
  return (
    !!searchParams.get('payment_intent_client_secret') &&
    !!searchParams.get('payment_intent') &&
    searchParams.get('redirect_status') !== 'failed'
  );
}

export { checkPaymentIntent };
